module.exports = __webpack_public_path__ + "img/keyboard-open.1b0c0704.svg";